import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Popover,
  Typography,
} from "@material-ui/core";
import {
  mdiClose,
  mdiDeleteOutline,
  mdiDotsHorizontal,
  mdiDownload,
  mdiFilter,
  mdiPlus,
} from "@mdi/js";
import Icon from "@mdi/react";
import classNames from "classnames";
import { CustomTableContext } from "components/CustomTable";
import { Routes } from "constants/routes";
import { get } from "lodash";
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";
import "../styles/header-table.scss";
import ExportTaskGroupData from "./ExportTaskGroupData";
import { FilterDrawerAllGroup } from "./FilterDrawerAllGroup";
import SearchButton from "./SearchButton";
import { TitleTable } from "./TitleTable";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import AddIcon from "@mui/icons-material/Add";

const HeaderTableAllGroup = ({
  currentGroup,
  setCurrentGroup,
  expand,
  onExpand,
  typeData,
  onOpenCreateModal = () => {},
  onOpenCreateGroupModal = () => {},
  onFilterType = () => {},
  onSearch = () => {},
  onSetTimeRangeAnchor = () => {},
  isDisplayGroupGrid,
  refFilterCustom,
  doEditProjectGroup,
  handleSelectColor,
  getCurrentGroup,
  ...props
}) => {
  const history = useHistory();
  const { t } = useTranslation();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const refMenuDrawer = useRef(null);
  const TableContext = React.useContext(CustomTableContext);

  const _toggleDrawerMenu = () => refMenuDrawer.current._toggle();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div
      id="header-table-group"
      className={`AllGroup__header--wrapper ${
        isDisplayGroupGrid ? "isAllGroup" : ""
      }`}
    >
      <div className="AllGroup__header--wrapper-inner">
        <TitleTable
          // don't show tilte when click on info icon
          isAllGroup={isDisplayGroupGrid}
          currentGroup={!isDisplayGroupGrid && currentGroup}
          setCurrentGroup={setCurrentGroup}
          expand={expand}
          typeData={typeData}
          onExpand={onExpand}
          doEditProjectGroup={doEditProjectGroup}
          handleSelectColor={handleSelectColor}
          getCurrentGroup={getCurrentGroup}
        />
        {!isDisplayGroupGrid ? (
          <div className={`AllGroup__header--right`}>
            <SearchButton
              valueSearch={get(TableContext?.options, "search.patern", "")}
              onSearch={(value) => onSearch(value)}
            />
            <div className={classes.wrapperButton} onClick={_toggleDrawerMenu}>
              <Icon path={mdiDotsHorizontal} size={1} />
              <span style={{ marginLeft: 5, color: "#333333" }}>
                {t("OPEN_MENU")}
              </span>
            </div>
            <div>
              <div className={classes.wrapperButton} onClick={handleClick}>
                {/* Create */}
                <Icon path={mdiPlus} size={1} />
              </div>
              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
              >
                <List>
                  <ListItem
                    button
                    key={t("DMH.VIEW.PGP.RIGHT.ALL.ADD_TABLE")}
                    className={classes.menuItem}
                    onClick={() => {
                      history.push({
                        pathname: "/projects/add-new",
                        state: {
                          groupID: currentGroup?.id,
                          groupName: currentGroup?.name,
                        },
                      });
                      // onOpenCreateModal();
                      setAnchorEl(null);
                    }}
                  >
                    <ListItemIcon className={classes.menuIcon}>
                      <AddIcon />
                    </ListItemIcon>
                    <ListItemText
                      className={classes.menuText}
                      primary={t("DMH.VIEW.PGP.RIGHT.ALL.ADD_TABLE")}
                    />
                  </ListItem>
                  <ListItem
                    button
                    key={t("DMH.VIEW.PGP.RIGHT.ALL.ADD_GROUP")}
                    className={classes.menuItem}
                    onClick={() => {
                      onOpenCreateGroupModal();
                      setAnchorEl(null);
                    }}
                  >
                    <ListItemIcon className={classes.menuIcon}>
                      <WorkspacesIcon />
                    </ListItemIcon>
                    <ListItemText
                      className={classes.menuText}
                      primary={t("DMH.VIEW.PGP.RIGHT.ALL.ADD_GROUP")}
                    />
                  </ListItem>
                </List>
              </Popover>
            </div>
            <MenuDrawer
              ref={refMenuDrawer}
              onFilterType={onFilterType}
              onSetTimeRangeAnchor={onSetTimeRangeAnchor}
              refFilterCustom={refFilterCustom}
              {...props}
            />
          </div>
        ) : (
          <div
            id="AllGroup__searchBox--isAllGroup"
            className={`AllGroup__header--right isAllGroup`}
          >
            <SearchButton
              valueSearch={get(TableContext?.options, "search.patern", "")}
              onSearch={(value) => onSearch(value)}
            />
            <div className={classes.wrapperButton} onClick={onOpenCreateModal}>
              <Icon path={mdiPlus} size={1} />
            </div>
            <MenuDrawer
              ref={refMenuDrawer}
              onFilterType={onFilterType}
              onSetTimeRangeAnchor={onSetTimeRangeAnchor}
              refFilterCustom={refFilterCustom}
              {...props}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const MenuDrawer = forwardRef(
  (
    {
      anchor = "right",
      filterType,
      labelType,
      timeType,
      onFilterType = () => {},
      onFilterLabel = () => {},
      onExportData = () => {},
      onSetTimeRangeAnchor = () => {},
      refFilterCustom = null,
    },
    ref
  ) => {
    function useQuery() {
      return new URLSearchParams(useLocation().search);
    }
    const { t } = useTranslation();
    const classes = useStyles();
    const history = useHistory();
    const [isOpen, setIsOpen] = useState(false);
    const refFilterT = useRef(null);
    const refFilter = refFilterCustom || refFilterT;
    const refExport = useRef(null);
    const query = useQuery();
    const isShared = query.get("is-shared");
    console.log(isShared, "isShared");
    useImperativeHandle(ref, () => ({ _toggle: toggleDrawer }));

    const toggleDrawer = () => {
      setIsOpen(!isOpen);
    };

    const DRAWER_MENU_ITEMS = [
      {
        text: t("PROJECT_FILTER"),
        icon: mdiFilter,
        onClick: () => refFilter.current._toggle(),
      },
      // {
      //   text: t("EXPORT_DATA"),
      //   icon: mdiDownload,
      //   onClick: () => refExport.current._toggle(),
      // },
      {
        text: t("TRASH"),
        icon: mdiDeleteOutline,
        onClick: () => history.push(`${Routes.PROJECTS}/deleted`),
      },
    ];

    return (
      <>
        <Box
          className={classNames(classes.drawerWrapper, { isCollapsed: isOpen })}
        >
          <div className={classes.drawerHeader}>
            <Typography
              variant="h3"
              component="h3"
              style={{ fontSize: 20, fontWeight: 500 }}
            >
              Menu
            </Typography>
            <Icon
              path={mdiClose}
              size={1}
              style={{ cursor: "pointer" }}
              onClick={toggleDrawer}
              className="custom-button-hover-round"
            />
          </div>

          <List>
            {DRAWER_MENU_ITEMS.map(
              ({ text, icon, onClick = () => {} }, index) =>
                isShared && text === t("EXPORT_DATA") ? (
                  <></>
                ) : (
                  <ListItem
                    button
                    key={text}
                    className={classes.menuItem}
                    onClick={onClick}
                  >
                    <ListItemIcon className={classes.menuIcon}>
                      <Icon path={icon} size={1} />
                    </ListItemIcon>
                    <ListItemText className={classes.menuText} primary={text} />
                  </ListItem>
                )
            )}
          </List>
        </Box>

        <FilterDrawerAllGroup
          ref={refFilter}
          filterType={filterType}
          labelType={labelType}
          timeType={timeType}
          onFilter={onFilterType}
          onFilterLabel={onFilterLabel}
          onCloseMainMenu={() => setIsOpen(false)}
          onSetTimeRangeAnchor={onSetTimeRangeAnchor}
        />
        <ExportTaskGroupData ref={refExport} onExportData={onExportData} />
      </>
    );
  }
);

const useStyles = makeStyles({
  wrapperButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    backgroundColor: "#ebedef",
    color: "#adaeba",
    marginLeft: 10,
    fontWeight: 500,
    padding: "10px 14px",
    borderRadius: 3,
    transition: "0.3s all ease-in-out",
    "& svg": {
      color: "#333333",
    },
    "&:hover": {
      backgroundColor: "#e5e5e5",
    },
  },
  drawerWrapper: {
    position: "fixed",
    bottom: "16px",
    right: 0,
    backgroundColor: "#fff",
    height: "calc(100% - 98px)",
    width: "300px",
    transform: "translateX(100%)",
    transition: "0.3s all ease-in-out",
    border: "1px solid #dddddd",
    boxShadow: "rgb(0 0 0 / 5%) 0px 1px 10px 0px",
    borderRadius: "20px",
    "&.isCollapsed": {
      transform: "translateX(0)",
    },
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
    padding: 18.5,
    fontSize: 21,
  },
  menuItem: { fontWeight: 500 },
  menuText: { "& span": { fontWeight: 400, color: "#666" } },
  menuIcon: { minWidth: 35 },
});

export default HeaderTableAllGroup;
